<template>
  <div class="privacy-policy-display policy-html-content" v-if="displayContent" v-html="displayContent">
  </div>
  <div v-else class="no-content">
    {{ type === 'privacy' ? 'Privacy Policy not available' : 'Terms & Conditions not available' }}
  </div>
</template>

<script>
export default {
  name: 'PublicPolicyDisplay',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['privacy', 'terms'].includes(value)
    }
  },
  computed: {
    content() {
      if (this.type === 'privacy') {
        return this.$store.state.Policies.public_privacy_policy?.content || '';
      } else {
        return this.$store.state.Policies.public_terms_conditions?.content || '';
      }
    },
    displayContent() {
      if (!this.content) return '';
      // If content already contains HTML tags (<p>, <h1>, <ul>, etc.)
      const hasHtml = /<[a-z][\s\S]*>/i.test(this.content);
      if (hasHtml) {
        return this.content;
      }
      // If content is plain text with \n, format paragraphs and line breaks
      return this.content
        .split(/\n\s*\n/)
        .map(paragraph => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`)
        .join('');
    }
  },
  mounted() {
    this.loadContent();
  },
  methods: {
    loadContent() {
      if (this.type === 'privacy') {
        this.$store.dispatch('Policies/get_public_privacy_policy');
      } else {
        this.$store.dispatch('Policies/get_public_terms_conditions');
      }
    }
  }
};
</script>

<style scoped>
.privacy-policy-display {
  font-family: inherit;
  line-height: 1.6;
  padding: 0;
  background-color: transparent;
  color: inherit;
  border: none;
}

/* Rich text styles inside v-html */
.privacy-policy-display :deep(p) {
  margin-bottom: 1rem;
}

.privacy-policy-display :deep(ul) {
  list-style-type: disc !important;
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.privacy-policy-display :deep(ol) {
  list-style-type: decimal !important;
  margin-bottom: 1rem;
  padding-left: 2rem;
}

.privacy-policy-display :deep(li) {
  margin-bottom: 0.35rem;
}

.privacy-policy-display :deep(strong) {
  font-weight: 600;
  color: #111827;
}

.privacy-policy-display :deep(h1),
.privacy-policy-display :deep(h2),
.privacy-policy-display :deep(h3),
.privacy-policy-display :deep(h4),
.privacy-policy-display :deep(h5),
.privacy-policy-display :deep(h6) {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.privacy-policy-display :deep(h1:first-child),
.privacy-policy-display :deep(h2:first-child),
.privacy-policy-display :deep(h3:first-child),
.privacy-policy-display :deep(p:first-child) {
  margin-top: 0;
}

.privacy-policy-display :deep(a) {
  color: #0d6efd;
  text-decoration: none;
}

.privacy-policy-display :deep(a:hover) {
  text-decoration: underline;
}

.privacy-policy-display :deep(blockquote) {
  border-left: 3px solid #d1d5db;
  padding-left: 1rem;
  margin-left: 0;
  margin-right: 0;
  color: #4b5563;
  font-style: italic;
  margin-bottom: 1rem;
}

.no-content {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 20px;
}
</style>